// extracted by mini-css-extract-plugin
export default {"entryContainer":"SimpleFAQItem_entryContainer__11yme","entryDetails":"SimpleFAQItem_entryDetails__E1XF+","entrySkeleton":"SimpleFAQItem_entrySkeleton__h9mXX"};